export const LOGOUT_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/logout',
};
//# sourceMappingURL=logout.js.map